export const FEATURES = {
  challenges: {
    follow: false,
  },
};
